import { Fragment, ReactNode, useState } from 'react'

// Показывает текст в формате Telegram (см. utils/tgFormat.ts) так, как его
// видит получатель: жирный, курсив, зачёркнутый, моноширинный, цитата, скрытый
// текст. Строим элементы React по белому списку тегов - никакого innerHTML,
// поэтому разметка из сообщения не может выполнить скрипт или сломать страницу.

function Spoiler({ children }: { children: ReactNode }) {
    const [revealed, setRevealed] = useState(false)
    return (
        <span
            className={revealed ? 'tg-spoiler is-revealed' : 'tg-spoiler'}
            onClick={(event) => {
                event.stopPropagation()
                setRevealed(true)
            }}
            title={revealed ? undefined : 'Скрытый текст - нажмите, чтобы показать'}
        >
            {children}
        </span>
    )
}

function renderNode(node: Node, key: number): ReactNode {
    if (node.nodeType === Node.TEXT_NODE) {
        return node.textContent
    }
    if (node.nodeType !== Node.ELEMENT_NODE) return null
    const element = node as Element
    const children = Array.from(element.childNodes).map((child, index) => renderNode(child, index))
    const tag = element.tagName.toLowerCase()

    switch (tag) {
        case 'b':
        case 'strong':
            return <strong key={key}>{children}</strong>
        case 'i':
        case 'em':
            return <em key={key}>{children}</em>
        case 'u':
            return <u key={key}>{children}</u>
        case 's':
        case 'strike':
        case 'del':
            return <s key={key}>{children}</s>
        case 'code':
            return <code key={key} className="tg-code">{children}</code>
        case 'pre':
            return <pre key={key} className="tg-pre">{children}</pre>
        case 'blockquote':
            return <blockquote key={key} className="tg-quote">{children}</blockquote>
        case 'tg-spoiler':
            return <Spoiler key={key}>{children}</Spoiler>
        case 'span':
            if (element.classList.contains('tg-spoiler')) return <Spoiler key={key}>{children}</Spoiler>
            return <Fragment key={key}>{children}</Fragment>
        case 'a': {
            const href = element.getAttribute('href') || ''
            if (!/^(https?:|tg:)/i.test(href)) return <Fragment key={key}>{children}</Fragment>
            return (
                <a key={key} href={href} target="_blank" rel="noopener noreferrer" onClick={(event) => event.stopPropagation()}>
                    {children}
                </a>
            )
        }
        default:
            return <Fragment key={key}>{children}</Fragment>
    }
}

export default function FormattedText({ html, className }: { html: string; className?: string }) {
    const doc = new DOMParser().parseFromString(`<body>${html || ''}</body>`, 'text/html')
    return (
        <span className={className ? `tg-formatted ${className}` : 'tg-formatted'}>
            {Array.from(doc.body.childNodes).map((node, index) => renderNode(node, index))}
        </span>
    )
}
